module.exports = "./img/avatar.png";